import mixpanel from '@webtrader/core/mix-panel';

import { EFeaturePopupAction } from '../constants';
import { eventNameHelper, userHelper } from '../helpers';

class FeaturePopupAnalysisService {
  public trackPopupAction = (action: EFeaturePopupAction) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(eventNameHelper.mapFeaturePopupAction(action), {
      ...userAccountProperties
    });
  };
}

const featurePopupAnalysisService = new FeaturePopupAnalysisService();
export default featurePopupAnalysisService;
